<template>
  <div>
    <div style="display:flex;justify-content:space-between;">
      <div class="title">
        我的质检
      </div>
      <div class="page-statistics">
        <div style="color:#999;">今日质检 / 累计质检</div>
        <div style="font-weight:600;font-size:16px;">
          {{ today_count }} / {{ total_count }}
        </div>
      </div>
    </div>
    <div class="mb-12">
      <el-select
        class="w-200 mr-12"
        v-model="skill_id"
        size="medium"
        filterable
        remote
        reserve-keyword
        clearable
        placeholder="技能栈"
        prefix-icon="el-icon-search"
        :remote-method="remoteMethod"
        :loading="selectLoading"
      >
        <el-option
          v-for="point in skill_points"
          :key="point.id"
          :label="point.name"
          :value="point.id"
        ></el-option>
      </el-select>
      <el-input
        size="medium"
        class="w-120 mr-12"
        v-model="stem"
        placeholder="题干"
      ></el-input>
      <el-select
        v-model="level"
        size="medium"
        @change="search"
        class="w-120 mr-12"
        placeholder="难度等级"
        clearable
      >
        <el-option label="简单" :value="1"></el-option>
        <el-option label="普通" :value="2"></el-option>
        <el-option label="困难" :value="3"></el-option>
      </el-select>
      <el-select
        class="w-120 mr-12"
        v-model="question_type"
        clearable
        @change="search"
        placeholder="题目类别"
        size="medium"
      >
        <el-option label="场景" :value="4"></el-option>
        <el-option label="概念" :value="2"></el-option>
        <el-option label="代码" :value="3"></el-option>
        <el-option label="其他" :value="1"></el-option>
      </el-select>
      <el-button type="primary" size="medium" plain @click="search"
        >查询</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
    </div>

    <el-table :data="list" v-loading="loading">
      <el-table-column label="编号" prop="id"></el-table-column>
      <el-table-column label="关联技能" prop="stack.name"></el-table-column>
      <el-table-column label="题干" prop="stem" width="120">
        <template slot-scope="scope">
          <el-tooltip effect="light" placement="right">
            <div class="hidden-redundant">{{ scope.row.stem }}</div>
            <div slot="content" class="tooltip-content">
              <MarkdownIt :md="scope.row.stem"></MarkdownIt>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="题目类别"
        prop="question_type_label"
      ></el-table-column>
      <el-table-column label="难度等级" prop="level_label"></el-table-column>
      <el-table-column
        label="质检时间"
        prop="verify_at"
        width="160"
      ></el-table-column>
      <el-table-column label="状态" prop="status" width="130">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="warning" size="medium"
            >已提交待审核</el-tag
          >
          <el-tag v-if="scope.row.status === 2" size="medium">通过入库</el-tag>
          <el-tag v-if="scope.row.status === 3" type="danger" size="medium"
            >质检不通过</el-tag
          >
          <el-tag v-if="scope.row.status === 4" type="danger" size="medium"
            >题目下架</el-tag
          >
          <el-tag v-if="scope.row.status === 6" size="medium"
            >审核通过待质检</el-tag
          >
          <el-tag v-if="scope.row.status === 7" type="danger" size="medium"
            >审核不通过</el-tag
          >
          <el-tag v-if="scope.row.status === 9" size="medium"
            >质检通过待终审</el-tag
          >
          <el-tag v-if="scope.row.status === 10" type="danger" size="medium"
            >题目作废</el-tag
          >
          <el-tag v-if="scope.row.status === 11" type="danger" size="medium"
            >终审驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="质检次数"
        prop="verify_pro_count"
      ></el-table-column>
      <el-table-column label="质检单价" prop="unit_price" width="120">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>题目单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            @click="handleDetail(scope.row)"
            v-if="
              authPermissions.includes(
                'question.api.fuwu_admin.skill_question_review_task.questions.show'
              )
            "
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import kcellService from "@/global/service/kcell";
import skillService from "@/global/service/skill";
import ShowHideContent from "@/components/ShowHideContent";
import { mapState } from "vuex";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
export default {
  components: {
    ShowHideContent,
    MarkdownIt
  },
  data() {
    return {
      skill_id: null,
      stem: null,
      level: null,
      question_type: null,
      selectLoading: false,
      skill_points: [],
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      isShow: false,
      loading: false,
      today_count: null,
      total_count: null
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
    this.getStatistics();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        stack_id: this.skill_id,
        stem: this.stem,
        level: this.level,
        question_type: this.question_type,
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize
      };
      skillService
        .skillQuestionReviewTaskTypeQuestionsMy(2, params)
        .then(res => {
          this.list = res.list;
          this.pagination.currentPage = res.pagination.current_page;
          this.pagination.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getStatistics() {
      skillService.skillQuestionReviewTaskTypeStatistics(2).then(res => {
        this.today_count = res.today_count;
        this.total_count = res.total_count;
      });
    },
    search() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    clearSearch() {
      this.skill_id = null;
      this.stem = null;
      this.level = null;
      this.question_type = null;
      this.pagination.currentPage = 1;
      this.getData();
    },
    goPage(e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleDetail(row) {
      let url = this.$router.resolve({
        name: "QuestionDetail",
        params: { id: row.uuid },
        query: {
          type: 2,
          verify_at: row.verify_at,
          verify_count: row.verify_pro_count
        }
      });
      window.open(url.href);
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectLoading = true;
        kcellService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title {
  font-size: 20px;
}
.page-statistics {
  color: #666;
  text-align: center;
  font-size: 14px;
}
.tooltip-content {
  max-width: 700px;
  border: none !important;
}
/deep/.el-tooltip__popper {
  border: none !important;
}
</style>
